import Vue from 'vue';
import { gsap } from 'gsap/all';
import Rellax from 'rellax';
import SplitText from '../gsap-bonus/SplitText';
import { Header } from '../classes/Header';

Vue.component('hero-component', {
    data() {
        return {

        };
    },

    mounted() {
        this.loadImage();
        this.loadVideo();

        const scrollTl = gsap.timeline({ repeat: -1 });

        scrollTl.to('.case-header__scroll-indicator span', {
            duration: 1,
            y: 0,
            delay: 1.2,
            ease: 'power1.inOut',
        });

        scrollTl.to('.case-header__scroll-indicator span', {
            duration: 1,
            top: 50,
            ease: 'power1.inOut',
        }, '-=0.3');

        const split = new SplitText('.case-header__title p', {
            type: 'lines,words',
            wordsClass: 'word word-++',
            linesClass: 'oh',
        });

        gsap.set(split.words, { yPercent: 100, autoAlpha: 0 });

        for (let index = 0; index < split.lines.length; index++) {
            const line = split.lines[index];

            const headerTl = gsap.timeline({ delay: 1 + (index * 0.15) });

            headerTl.to('.case-header__overlay', { autoAlpha: 1 });
            headerTl.to(line.querySelectorAll('.word'), {
                yPercent: 0, autoAlpha: 1, stagger: 0.01, duration: 1.2, ease: 'power3.out',
            });

            if (index === 0) {
                headerTl.to('.case-header__client', { autoAlpha: 1 });
            }
        }

        this.initParallax();
    },

    methods: {
        loadImage() {
            const picture = this.$refs.texture;

            if (!picture) {
                return;
            }

            const image = document.createElement('img');
            image.onload = () => {
                this.mount({
                    type: 'image',
                    url: image.src,
                });
            };

            const setSource = () => {
                if (!picture.currentSrc || picture.currentSrc.startsWith('data')) {
                    setTimeout(() => {
                        setSource();
                    }, 400);
                } else {
                    image.src = picture.currentSrc;
                }
            };

            setSource();
        },

        loadVideo() {
            let video = this.$refs.videoTexture;

            if (!video) {
                return;
            }

            if (window.matchMedia('(orientation: portrait)').matches) {
                video = this.$refs.videoTexturePortrait;
            }

            if (!video) {
                return;
            }

            this.mount({
                type: 'video',
                url: video.dataset.src,
            });
        },

        mount(media) {
            this.header = [{
                media,
            }];

            this.showcase = new Header(this.header, {
                onActiveIndexChange: (activeIndex) => {
                    this.activeIndex = activeIndex;
                },
                onIndexChange: (index) => {
                    // this.slider.onMove(index);
                },
                onZoomOutStart: ({ activeIndex }) => {
                    // this.$root.cursor.enter();
                },
                onZoomOutFinish: ({ activeIndex }) => {

                },
                onFullscreenStart: ({ activeIndex }) => {
                    // this.$root.cursor.leave();
                },
                onFullscreenFinish: ({ activeIndex }) => {

                },
            });

            this.showcase.mount(this.$refs.container);
            this.showcase.render();

            EventBus.$emit('image-loaded');
            window.addEventListener('resize', this.onResize);
        },

        onResize() {
            this.showcase.onResize();
        },

        initParallax() {
            const parallaxEl = this.$el.querySelector('.case-header__element-container');

            gsap.to(parallaxEl, {
                y: parallaxEl.offsetHeight * 0.28,
                ease: 'none',
                scrollTrigger: {
                    trigger: '.case-header',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                },
            });

            if (window.innerWidth > 1024) {
                setTimeout(() => {
                    const rellax = new Rellax('.rellax');
                }, 1000);
            }
        },
    },

    beforeDestroy() {
        if (this.showcase) {
            this.showcase.GL.cancelLoop();
        }
        window.removeEventListener('resize', this.onResize);
    },
});
